import React from 'react';

const Vue_component = () => {
  return (
    <div>
      <h1>Vue_component Component</h1>
      <p>This is the Vue_component tutorial page.</p>
    </div>
  );
}

export default Vue_component;
